<template>
  <BContainer class="container-pages" v-if="advertisementDisplay">
        <BRow>
         <BCol>
             <h1 class="h1-title">{{advertisementDisplay?.title}}</h1>
             <h2 class="text-info h2-subtitle text-uppercase" > 
               <NuxtLink :to="{name:`oglasi-category-page`, params:{category:$srbTolat.srbTolat(advertisementDisplay?.category_name), page:1}}">
                          <span class="category-ads-span font-weight-bold">{{advertisementDisplay?.category_name}}</span>
               </NuxtLink>  
                                               | 
               <NuxtLink :to="{name:`oglasi-category-subcategory-page`,params:{category:$srbTolat.srbTolat(advertisementDisplay?.category_name), subcategory: $srbTolat.srbTolat(advertisementDisplay?.subcategory_name), page: 1}}">
                          <span class="category-ads-span font-weight-bold">{{advertisementDisplay?.subcategory_name}}</span>
               </NuxtLink>
             </h2>
              <hr>     
         </BCol>   
      </BRow>
     <BRow
  v-if="advertisementDisplay?.coupon === 1 && !cms"
  class="mb-3 mt-2"
>
  <BCol>
    <div class="coupon-card">
      <!-- <div class="coupon-card__icon">
        <i class="bi bi-ticket-perforated"></i>
      </div> -->

      <div class="coupon-card__content">
        <div class="coupon-card__badge">
          OGLAS SA KUPONOM  
        </div>

        <div class="coupon-card__title">
          Kupi sa kuponom
        </div>

        <div class="coupon-card__text">
          Iskoristite kupon za ovaj oglas i ostvarite pogodnost pri kupovini. Za više informacija i aktivaciju kupona, pozovite tezgu <span class="fw-bold">{{ advertisementDisplay?.lawyer_name }}</span> (prodavca).
        </div>
      </div>
    </div>
  </BCol>
</BRow>
      <BRow v-if="advertisementDisplay?.lawyer === 1 && !cms" class="mb-3 mt-2">
  <BCol>
    <div class="tezga-profile-card">
      <div class="tezga-profile-card-content">
        <div class="tezga-profile-card-text">
             <NuxtLink
        
          
          :to="{
            name: 'tezga-lawyername-page',
            params: {
              lawyername: advertisementDisplay?.name_slug,
              page: 1
            }
          }"
        >
       
        
          <div class="tezga-profile-badge">
            <i class="esei icon-store-solid me-2"></i>
            Tezga profil
          </div>

          <h5 class="tezga-profile-title mb-2 text-uppercase">
            Ovo je profil registrovane tezge!
          </h5>
</NuxtLink>
 <NuxtLink
    :to="routePath({ name: 'kako-kreirati-tezga-profil'})"

  >
          <p class="tezga-profile-description mb-0 text-info">
         Registrujte <strong>BESPLATNO</strong> TEZGU i objavljujte oglase!
          </p>
          </NuxtLink>
        </div>

        <div class="tezga-profile-card-logo">
          <div class="tezga-profile-logo-circle">
            <i class="esei icon-store-solid"></i>
          </div>
        </div>
      </div>
    </div>
  </BCol>
</BRow>
    </BContainer>
</template>

<script setup>

const { $srbTolat } = useNuxtApp()

import { BContainer, BRow, BCol } from 'bootstrap-vue-next';
 const routePath = useRoutePath()
const props = defineProps({
    advertisement:{
        required: true,
        type : Object
    },
     cms: {
        type: Boolean,
        default: false
      }
})

const advertisementDisplay = ref();

watchEffect(() => {
    advertisementDisplay.value = props.advertisement
})
</script>

 
